'use strict';

var Core     = require('./core.js');
var $         = require('jquery');
// var interact = require('interact.js');

/**
 * DraggableCore
 * inherits from Core, adds methods for draggable support
 */

class DraggableCore extends Core  {

    constructor(options) {
        super(options);
    }

    render(override){
        super.render(override);

        /**
         * DraggleHandle Mouse Down
         *
         * @fires DraggableCore#_draggableHandlerMouseDown
         */

         $('.js-cio-ui-templates__draggable__handle', this.$el).on('mousedown', this._draggableHandlerMouseDown);


        /**
         * DraggleHandle Mouse Up
         *
         * @fires DraggableCore#_draggableHandlerMouseUp
         */

         $('.js-cio-ui-templates__draggable__handle', this.$el).on('mouseup', this._draggableHandlerMouseUp);

        /**
         * DraggleHandle Move
         *
         * @fires DraggableCore#_draggableHandlerMouseUp
         */

         $('.js-cio-ui-templates__draggable__handle', this.$el).on('mousemove', this._draggableHandlerMouseMove);

    }

    /**
     * @event DraggableCore#ioui:Draggable:MouseDown
     * @property {String}ioui:Draggable:MouseDown
     * @returns {Event} e - mouse event
     */

    _draggableHandlerMouseDown(e){
        $(e.currentTarget).trigger('Cioui:Draggable:MouseDown', e);
    }

    /**
     * @event DraggableCore#ioui:Draggable:MouseUp
     * @property {String}ioui:Draggable:MouseUp
     * @returns {Event} e - mouse event
     */

    _draggableHandlerMouseUp(e){
        $(e.currentTarget).trigger('Cioui:Draggable:MouseUp', e);
    }

    /**
     * @event DraggableCore#ioui:Draggable:MouseMove
     * @property {String}ioui:Draggable:MouseMove
     * @returns {Event} e - mouse event
     */

    _draggableHandlerMouseMove(e){
        $(e.currentTarget).trigger('Cioui:Draggable:MouseMove', e);
    }

    /**
     * add mouse move cursor css class
     */

    addMoveCursor(){
        $('.js-cio-ui-templates__draggable__handle', this.$el).addClass("mouse--move");
    }

    /**
     * Sets X and Y of draggable element
     * @param {Integer} x - x pos
     * @param {Integer} y - y pos
     */

    setPos(x, y){
        // RELATIVE
        // this.$el.find('>').css({'transform': 'translate(' + x + 'px, ' + y + 'px)'});
        // this.$el.find('>').css({'-webkit-transform': 'translate(' + x + 'px, ' + y + 'px)'});

        // ABSOLUTE INSIDE EDITOR VIEW
        // var parentPosX = this.$el.parent().offset().left;
        // var parentPosY = this.$el.parent().offset().top;
        // this.$el.find('>').css({'left': x - parentPosX + 'px'});
        // this.$el.find('>').css({'top': y - parentPosY + 'px'});

        // ABSOLUTE
        this.$el.css({'left': x + 'px'});
        this.$el.css({'top': y + 'px'});
    }

}

module.exports = DraggableCore;
